import { Controller, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { useGetWorkbenchTypesQuery } from '~/api/v2/hooks';

const WorkbenchGroupField = () => {
  const projectId = +useParams().projectid!;
  const { data: typesData, isFetching } = useGetWorkbenchTypesQuery({ projectId });
  const { control } = useFormContext();

  return (
    <FormControlLabel
      required
      label="WORKBENCH GROUP"
      control={
        <Controller
          name="workbenchGroup"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <FormHelperText error={!!fieldState.error}>{fieldState.error?.message}</FormHelperText>
              <Select {...field} value={field.value ?? ''} disabled={isFetching} error={!!fieldState.error}>
                {Object.keys(typesData || {})?.map((el) => (
                  <MenuItem value={el} key={el}>
                    {el}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        />
      }
    />
  );
};

export default WorkbenchGroupField;
